import React from 'react';
import PropTypes from 'prop-types';
import WorkOrderNotification from 'workOrderComponents/WorkOrderNotification';
import {FormattedDate, FormattedTime} from 'react-intl';
import * as apiUrlsAndConstants from "../../constants/apiUrls";

const OutageDisplay = (props) => {

    const {nodeOutage, onRefresh, loadingMessage, isLoading} = props;

    const outages = [];

    let dateProp = 'openedDateTime';
    let treePropertyPath = ['details'];
    let outageTypeProp = 'outageType';

    if(apiUrlsAndConstants.USE_WORKORDER_OUTAGES_LEGACY_API){
        dateProp ='createdDate';
        treePropertyPath =['details', 'outages'];
        outageTypeProp ='type';
    }

    if (nodeOutage) {


        const currentOutages = nodeOutage.getIn(treePropertyPath);

        if (currentOutages) {
            currentOutages.forEach((outage, index) => {
                let seperator = null;
                if (props.nodeOutage.getIn(treePropertyPath).count() - 1 !== index) {
                    seperator = (
                        <span>
                            &nbsp; | &nbsp;</span>
                    );
                }

                outages.push(
                    <span key={'outage_' + index}>
                        <a
                            className="red-text text-darken-2"
                            style={{
                            textDecoration: 'underline'
                        }}
                            href={outage.get('link')}
                            target="_blank">{outage.get(outageTypeProp) || 'Outage'}&nbsp;Created:&nbsp;
                            <FormattedDate value={outage.get(dateProp)} year="2-digit" month="2-digit" day="2-digit"/>&nbsp;
                            <FormattedTime value={outage.get(dateProp)}/>
                        </a>
                        {seperator}
                    </span>
                );
            });
        }

    }

    return (
        <div>
            <WorkOrderNotification
                onRefresh={onRefresh}
                loadingMessage={loadingMessage}
                isLoading={isLoading}
                hasData={outages.length > 0}
                icon="warning"
                textClass="red-text text-darken-2"
                iconColor="red-text text-darken-2"
                className="">
                <div>

                    {outages}

                </div>
            </WorkOrderNotification>
        </div>
    );

};

OutageDisplay.propTypes = {
    onRefresh: PropTypes.func,
    isLoading: PropTypes.bool,
    loadingMessage: PropTypes.string,
    nodeOutage: PropTypes.object
};

export default OutageDisplay;



// WEBPACK FOOTER //
// ./src/components/work-order/OutageDisplay.js